import * as uuid from "uuid";
import moment from "moment";
// React
import React from "react";
// Charts
import Chart from "react-google-charts";
// Utils
import * as utils from "office/reports/stats/utils/utils";
import * as GraphHelper from "common/utils/GraphHelper";
import { resizeHelper } from "common/resizeHelper";
import MissingProductInfo from "office/reports/stats/components/missingProductInfo/MissingProductInfo";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "common/ui/components/graphs/Graph.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class GraphDoubleAxis extends React.Component {
    constructor(props) {
        super(props);
        this._reportId = "";
        this._reportId = uuid.v4();
        this.state = {};
    }
    componentDidMount() {
        resizeHelper.addListener(this._reportId, (width, height) => this.onResize(width, height));
    }
    componentWillUnmount() {
        resizeHelper.removeListener(this._reportId, (width, height) => this.onResize(width, height));
    }
    onResize(width, height) {
        // Force redraw
        this.setState({});
    }
    render() {
        let { title, xAxis, yAxis, series, seriesColours, fromDate, toDate, vAxis1ValuesVisible } = this.props;
        // No data
        if (!utils.findSeriesWithData(series)) {
            return (React.createElement("div", { className: styles.noGraphData },
                React.createElement(MissingProductInfo, { text: "No Graph Data", isLarge: true })));
        }
        // Create the default series options
        let seriesOptions = utils.createDefaultSeriesOptions(seriesColours);
        // Override to set Second vAxis options
        let lastIndex = seriesOptions.length - 1;
        seriesOptions[lastIndex].targetAxisIndex = 1;
        seriesOptions[lastIndex].areaOpacity = 0;
        seriesOptions[lastIndex].lineWidth = 1;
        seriesOptions[lastIndex].pointsVisible = false;
        seriesOptions[lastIndex].lineDashStyle = [4, 4];
        // Max values
        let maxGridlines = utils.calcVAxisGridlineCount(series);
        // Columns
        let columns = [{ label: "days", type: "date" }];
        for (var label of this.props.seriesLabels) {
            columns.push({ label: label, type: "number" });
        }
        // Create graph options
        let options = {
            title: title,
            titleTextStyle: GraphHelper.defaulTitleTextStyle,
            vAxes: {
                0: new GraphHelper.DefaultVAxis_Number(yAxis, maxGridlines, vAxis1ValuesVisible != null ? vAxis1ValuesVisible : true),
                1: new GraphHelper.DefaultVAxis_Number("Listings", maxGridlines)
            },
            hAxis: new GraphHelper.DefaultHAxis_Time(null, utils.calcDayTicks(moment(fromDate), moment(toDate))),
            legend: { position: "bottom" },
            animation: GraphHelper.defaultAnimation,
            lineWidth: 2,
            pointSize: 4,
            series: seriesOptions,
            focusTarget: 'category'
        };
        return (React.createElement("div", { className: styles.graph },
            React.createElement(Chart.Chart, { chartType: "AreaChart", graph_id: this._reportId, options: options, width: GraphHelper.defaultGraphWidth, height: GraphHelper.defaultGraphHeight, rows: series, columns: columns })));
    }
}
